import { AbsoluteFill, Sequence } from "remotion";
import { SCENE, COLORS } from "./constants";
import { Scene01Title } from "./Scene01Title";
import { Scene02Vision } from "./Scene02Vision";
import { Scene03Principles } from "./Scene03Principles";
import { Scene04Problem } from "./Scene04Problem";
import { Scene05Architecture } from "./Scene05Architecture";
import { Scene06Phase1 } from "./Scene06Phase1";
import { Scene07Phase2 } from "./Scene07Phase2";
import { Scene08Phase3 } from "./Scene08Phase3";
import { Scene09Phase4 } from "./Scene09Phase4";
import { Scene10Phase5 } from "./Scene10Phase5";
import { Scene11Market } from "./Scene11Market";
import { Scene12Outro } from "./Scene12Outro";

export const EAKCVisionRoadmap: React.FC = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: COLORS.bg }}>
      <Sequence from={SCENE.title.start} durationInFrames={SCENE.title.duration}>
        <Scene01Title />
      </Sequence>

      <Sequence from={SCENE.vision.start} durationInFrames={SCENE.vision.duration}>
        <Scene02Vision />
      </Sequence>

      <Sequence from={SCENE.principles.start} durationInFrames={SCENE.principles.duration}>
        <Scene03Principles />
      </Sequence>

      <Sequence from={SCENE.problem.start} durationInFrames={SCENE.problem.duration}>
        <Scene04Problem />
      </Sequence>

      <Sequence from={SCENE.architecture.start} durationInFrames={SCENE.architecture.duration}>
        <Scene05Architecture />
      </Sequence>

      <Sequence from={SCENE.phase1.start} durationInFrames={SCENE.phase1.duration}>
        <Scene06Phase1 />
      </Sequence>

      <Sequence from={SCENE.phase2.start} durationInFrames={SCENE.phase2.duration}>
        <Scene07Phase2 />
      </Sequence>

      <Sequence from={SCENE.phase3.start} durationInFrames={SCENE.phase3.duration}>
        <Scene08Phase3 />
      </Sequence>

      <Sequence from={SCENE.phase4.start} durationInFrames={SCENE.phase4.duration}>
        <Scene09Phase4 />
      </Sequence>

      <Sequence from={SCENE.phase5.start} durationInFrames={SCENE.phase5.duration}>
        <Scene10Phase5 />
      </Sequence>

      <Sequence from={SCENE.market.start} durationInFrames={SCENE.market.duration}>
        <Scene11Market />
      </Sequence>

      <Sequence from={SCENE.outro.start} durationInFrames={SCENE.outro.duration}>
        <Scene12Outro />
      </Sequence>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
